import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { MeDto } from '@pl/domain';
import { useState, type FormEvent } from 'react';
import { Navigate, useNavigate } from 'react-router';
import { api } from '../lib/api';
import { qk, rememberMe, useMe } from '../lib/queries';
import { homeFor } from './roles';
import s from './LoginPage.module.css';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const qc = useQueryClient();
  const nav = useNavigate();
  const me = useMe();
  const login = useMutation({
    mutationFn: () => api.post<MeDto>('/auth/login', { email, password }),
    onSuccess: (data) => {
      qc.setQueryData(qk.me, rememberMe(data));
      nav(homeFor(data.role), { replace: true });
    },
  });
  // `me.data` can be the identity this phone remembers rather than one the server has just
  // confirmed. With an error standing beside it — a 401 says the session is gone — signing in is
  // exactly what this person needs to do, so the form stays.
  if (me.data && !me.error) return <Navigate to={homeFor(me.data.role)} replace />;
  const submit = (e: FormEvent) => {
    e.preventDefault();
    login.mutate();
  };
  return (
    <div className={s.page}>
      <form className={s.card} onSubmit={submit}>
        <div className={s.brand}>
          <div className="brand-mark">
            <i />
          </div>
          <div className="brand-name">
            PALLET<span>·</span>LEVEL
          </div>
        </div>
        <label className="fld">
          <span>Email</span>
          <input className="inp" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </label>
        <label className="fld">
          <span>Password</span>
          <input className="inp" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </label>
        {login.error && (
          <p role="alert" className={s.error}>
            {login.error.message}
          </p>
        )}
        <button className="bigbtn accent" type="submit" disabled={login.isPending}>
          Sign in
        </button>
        <p className={s.note}>You stay signed in on this device for 30 days.</p>
      </form>
    </div>
  );
}
